import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center relative rounded-2xl overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20background%20with%20soft%20flowing%20curves%20in%20coral%20and%20amber%20tones%2C%20elegant%20minimalist%20design%2C%20gentle%20light%20effects%2C%20modern%20clean%20aesthetic%2C%20professional%20atmosphere&width=1200&height=500&seq=cta-bg-aiye-01&orientation=landscape"
              alt=""
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-r from-primary-700/85 to-primary-800/85"></div>

          <div className="relative z-10 py-14 md:py-16 px-6">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-white mb-3">
              准备好开始了吗？
            </h2>
            <p className="text-sm text-white/80 mb-8 max-w-md mx-auto">
              无需下载安装，打开浏览器即可立即体验爱液网页版的全部功能
            </p>
            <Link
              to="/category/rumen"
              className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-white text-primary-700 font-semibold text-sm hover:bg-white/95 transition-all duration-200 hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              立即开始使用
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}